module.exports = __webpack_public_path__ + "static/media/folder_color-5.66dd440b.svg";